import _Dashboard from '@/components/dashboardPage/Dashboard';
import useAmplitude from '@/hooks/useAmplitude';

export const Dashboard = () => {
  useAmplitude('dashboard');
  return <_Dashboard />;
};

export default Dashboard;
